import axios from 'axios';
import Cookie from 'cookies-js';
import jwt from 'jsonwebtoken';
import config from '../../config/index';
import routes from '../../constants/routes';
import { GET_FIX_TIP_INVESTMENT } from '../types';

// Reducer object dispenser
const getUserFixTip = fixTip => ({
  type: GET_FIX_TIP_INVESTMENT,
  fixTip
});

// This Method fetches all user fix tip investment using the customer id
const fetchFixTip = () => (dispatch) => {
  const token = Cookie.get('jwtToken');
  const decodeToken = jwt.decode(token);
  const { customerId } = decodeToken;
  return axios.get(
    `${config.apiUrl}${routes.GETFIXTIPINVEST}/${customerId}`,
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  ).then((response) => {
    const {
      fixtips,
      isSuccessful
    } = response.data;
    if (isSuccessful) {
      dispatch(getUserFixTip(fixtips));
    }
  }).catch((error) => {
    throw error;
  });
};

export default fetchFixTip;
